<template>
  <div
    class="no-shrink"
    :class="{ active: active }"
  >
    <BaseInputText
      v-model="handleAuthors"
      :disabled="disabled"
      new-design
    >
      <template #label>
        <div class="q-mb-sm">
          <span :class="contentStyle">
            {{ $t("authors_expandable.handle") }}
          </span>
          <span class="smaller softer">{{
            $t("authors_expandable.comma_separated")
          }}</span>
        </div>
      </template>
    </BaseInputText>
  </div>
</template>

<script>
import { BaseInputText } from "shared/components/base";

export default {
  name: "AuthorsExpandable",
  components: {
    BaseInputText,
  },
  props: {
    authors: {
      type: Array,
      default: () => [],
    },
    contentStyle: {
      type: String,
      default: "",
    },
    active: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
  emits: ["update:authors", "search"],
  computed: {
    handleAuthors: {
      get() {
        return this.authors[0];
      },
      set(val) {
        this.$emit("update:authors", val?.length ? [val] : []);
        this.$emit("search");
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.active {
  background-color: $white;
}
</style>
